var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSugar = function SvgSugar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Sugar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Sugar_svg__b)",
    d: "M18.998.191C8.628.191.188 8.627.188 19.001s8.436 18.81 18.81 18.81 18.81-8.44 18.81-18.81S29.368.191 18.998.191m0 35.606c-4.226 0-8.083-1.58-11.04-4.168l3.588-3.591a1.005 1.005 0 0 0 0-1.425 1.005 1.005 0 0 0-1.425 0L6.526 30.21c-2.68-2.975-4.324-6.9-4.324-11.21 0-9.26 7.535-16.796 16.795-16.796 4.31 0 8.231 1.646 11.21 4.325l-3.53 3.534a1.005 1.005 0 0 0 0 1.425.999.999 0 0 0 1.421 0l3.523-3.527c2.588 2.957 4.169 6.81 4.169 11.04 0 9.26-7.536 16.795-16.796 16.795z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Sugar_svg__c)",
    d: "m18.754 11-.293.134-7.207 3.242-.236.1a.31.31 0 0 0-.19.286v8.753c0 .112.06.215.159.27l.202.113 7.207 4.008.208.118a.31.31 0 0 0 .305 0l.209-.118 7.206-4.008.202-.112a.32.32 0 0 0 .16-.27v-8.754a.31.31 0 0 0-.19-.286l-.237-.1-7.207-3.242L18.76 11zm.127 1.634 4.814 2.153c.24.106.246.445.012.563l-4.814 2.405a.31.31 0 0 1-.276 0l-4.814-2.405a.312.312 0 0 1 .012-.563l4.814-2.153a.3.3 0 0 1 .255 0zm-6.161 3.793 5.144 2.57a.31.31 0 0 1 .17.277v6.239a.312.312 0 0 1-.463.27l-5.144-2.853a.31.31 0 0 1-.158-.27v-5.956a.31.31 0 0 1 .451-.277m12.518.277v5.955a.31.31 0 0 1-.159.271l-5.143 2.854a.312.312 0 0 1-.464-.271v-6.24c0-.117.066-.226.171-.276l5.144-2.57a.312.312 0 0 1 .451.277"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sugar_svg__b",
    x1: 9.592,
    x2: 34.672,
    y1: 0.191,
    y2: 37.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sugar_svg__c",
    x1: 14.792,
    x2: 26.466,
    y1: 11,
    y2: 27.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Sugar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h38v38H0z"
  })))));
};
export default SvgSugar;